// extracted by mini-css-extract-plugin
module.exports = {"root":"Search_root__Uw2_3","icon":"Search_icon__t0hWH","input":"Search_input__v9GQz"};